import client from '../lib/request'

export default {
  getShopData(param = {}) {
    return client.post('admin/getShopData', param)
  },
}
